
(function() {
  const events = function() {

    $(document).on('click', '.glossary__search .is-available a', (e) => {
      const el = $(e.currentTarget);
      const section = el.attr('href');
      e.preventDefault();
      e.stopPropagation();

      if (section && $(".search")[0].value.length ) {
        $(".search")[0].value = '';
        $(".search").trigger('input');
      }

      if (section && !$(".search")[0].value.length ) {

        $('html, body').animate({
          scrollTop: $(section).offset().top-80
        }, 1000);
      }

    })

    $(".search").on("keyup click input", function () {
      const search_selector = '.glossary__list__item, .glossary__list__header, .glossary__list__headway';
      const search = $(".search").val().toLowerCase();

      if (this.value.length > 0) {
          $('.glossary__search__input svg').css('fill', '#4c5363');
          $(search_selector).show().filter(function () {
              
              const highlight = add_highlight(this, search);
        
              $(this).find('a').html( highlight );

              return !($(this).data('term').toLowerCase().indexOf(search) != -1);
          
            }).hide();
      }
      if (this.value.length > 0 && !$(search_selector).is(':visible')) { 
        $('.glossary__no-results').addClass('is-visible');
        $('.current-search').text( search )
      }
      if (this.value.length <= 0) {
        $('.glossary__search__input svg').css('fill', '#8b8f9e');
          $(search_selector).each(function() {
            const clear = clear_highlight(this);
            
            $(this).find('a').html( clear );
            $('.glossary__no-results').removeClass('is-visible');
          }).show();
          
      }
    });
  }

  const add_highlight = function (elm, match) {
    const original = $(elm).data('term');
    const matchStart = $(elm).text().toLowerCase().indexOf("" + match.toLowerCase() + "");
    const matchEnd = matchStart + match.length - 1;
    const outputStart = $(elm).text().slice(0, matchStart);
    const matchText = $(elm).text().slice(matchStart, matchEnd + 1);
    const outputEnd = $(elm).text().slice(matchEnd + 1);
    const highlight = matchText.length ? outputStart + "<mark>" + matchText + "</mark>" + outputEnd : original;
    
    return highlight;
  }

  const clear_highlight = function (elm) {
    
    return $(elm).data('term');
  }

  events()
})()
